import { useState } from 'react'
import { Stack, Chip, Popover, FormControlLabel, Switch } from '@vapor/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp, faLayerGroup } from '@fortawesome/pro-solid-svg-icons'
import { HiCIcon } from 'src/app/components/icons/icon'
import { useTranslation } from 'react-i18next'

type ProductionAssignedViewOptionsProps = {
  rowChildrenExpanded: boolean
  setRowChildrenExpanded: (expanded: boolean) => void
  groupedStayView: boolean
  setGroupedStayView: (enabled: boolean) => void
  groupedCityTaxView: boolean
  setGroupedCityTaxView: (enabled: boolean) => void
  groupedExtraView: boolean
  setGroupedExtraView: (enabled: boolean) => void
}

export const ProductionAssignedViewOptions = (props: ProductionAssignedViewOptionsProps) => {
  const {
    //
    rowChildrenExpanded,
    setRowChildrenExpanded,
    groupedStayView,
    setGroupedStayView,
    groupedCityTaxView,
    setGroupedCityTaxView,
    groupedExtraView,
    setGroupedExtraView,
  } = props

  const { t } = useTranslation()

  const [anchorGroupedPopover, setAnchorGroupedPopover] = useState<HTMLElement | null>(null)

  return (
    <Stack direction={'row'} gap={1}>
      <Chip
        size="small"
        label={t('pms.booking.reservation.productions_assigned.open_rows')}
        icon={
          <HiCIcon>
            <FontAwesomeIcon icon={faChevronDown} />
          </HiCIcon>
        }
        variant={rowChildrenExpanded ? 'outlined' : 'filled'}
        onClick={() => {
          setRowChildrenExpanded(true)
        }}
      />
      <Chip
        size="small"
        label={t('pms.booking.reservation.productions_assigned.close_rows')}
        icon={
          <HiCIcon>
            <FontAwesomeIcon icon={faChevronUp} />
          </HiCIcon>
        }
        variant={rowChildrenExpanded ? 'filled' : 'outlined'}
        onClick={() => {
          setRowChildrenExpanded(false)
        }}
      />
      <Chip
        size="small"
        label={t('pms.booking.reservation.productions_assigned.grouped_chip')}
        icon={
          <HiCIcon>
            <FontAwesomeIcon icon={faLayerGroup} />
          </HiCIcon>
        }
        variant={groupedStayView || groupedExtraView || groupedCityTaxView ? 'outlined' : 'filled'}
        onClick={(event) => {
          setAnchorGroupedPopover(event.currentTarget)
        }}
      />
      <Popover
        open={anchorGroupedPopover !== null}
        anchorEl={anchorGroupedPopover}
        onClose={() => {
          setAnchorGroupedPopover(null)
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Stack padding={1}>
          <FormControlLabel
            label={t('pms.booking.reservation.productions_assigned.grouped_stay')}
            control={
              <Switch
                checked={groupedStayView}
                onChange={(_, value) => {
                  setGroupedStayView(value)
                }}
              />
            }
          />
          <FormControlLabel
            label={t('pms.booking.reservation.productions_assigned.grouped_city_tax')}
            control={
              <Switch
                checked={groupedCityTaxView}
                onChange={(_, value) => {
                  setGroupedCityTaxView(value)
                }}
              />
            }
          />
          <FormControlLabel
            label={t('pms.booking.reservation.productions_assigned.grouped_extra')}
            control={
              <Switch
                checked={groupedExtraView}
                onChange={(_, value) => {
                  setGroupedExtraView(value)
                }}
              />
            }
          />
        </Stack>
      </Popover>
    </Stack>
  )
}
